export default "__VITE_ASSET__jYXcuy_r__"